<div [formGroup]="controlFormGroup">
  <label [class.is-invalid-label]="hasErrors()" class="input__label">
    {{ controlName | controlNameToHuman | snakeCaseToHuman }}
    <a *ngIf="controlName === 'role'" class="muted-color" [matMenuTriggerFor]="helpRolesMenu" data-cy="role-help">
      <i class="fa fa-question-circle"></i>
    </a>
    <mat-menu #helpRolesMenu="matMenu" class="mat-menu--with-content">
      <rav-help-roles></rav-help-roles>
    </mat-menu>
    <select
      [name]="controlName"
      [class.is-invalid-input]="hasErrors()"
      [class.margin-bottom-none]="!hasErrors()"
      [formControlName]="controlName"
    >
      <option value="" disabled selected>Select</option>
      <option *ngFor="let option of selectOptions" [value]="option.value">
        {{ option.name }}
      </option>
    </select>
  </label>
</div>

<rav-field-errors
  [controlFormGroup]="controlFormGroup"
  [controlName]="controlName"
  [hasErrors]="hasErrors()"
></rav-field-errors>
